import { createContext } from 'react';
import { noop } from 'lodash-es';

export const AccordionContext = createContext({
  openedItems: [],
  onToggleItem: noop,
});
